export interface Product {
  id: string;
  name: string;
  price: number;
  description: string;
  category: string;
  features: string[];
  available?: string[];
  imageUrl: string;
}

// --- VIDEO 1: PRODUCTOS FINALES AVIF (11 ÍTEMS) ---
const VIDEO1_PRODUCTS: Product[] = [
  { id: '1-v1', name: 'Buchi Fresa Especial', price: 85, description: 'Ramo extravagante y fino para sorprender a mamá.', category: 'Ramos Premium', features: ['Diseño Exclusivo', 'Flores Personalizables'], imageUrl: '/assets/products/video1/1.avif' },
  { id: '2-v1', name: 'Cayetana Real', price: 90, description: 'Un arreglo con estilo y presencia imponente.', category: 'Gama Alta', features: ['Elegancia Superior', 'Soporte de flor'], imageUrl: '/assets/products/video1/2.avif' },
  { id: '3-v1', name: 'Cajitas de Amor', price: 75, description: 'Diseño versátil con flores eternas.', category: 'Detalles', features: ['Base artesanal', 'Eterno'], imageUrl: '/assets/products/video1/3.avif' },
  // { id: '4-v1', name: 'Ameli Prestige', price: 55, description: 'Prestigio y elegancia en un detalle eterno.', category: 'Edición Limitada', features: ['Papel de Lujo', 'Premium'], imageUrl: '/assets/products/video1/4.avif' },
  { id: '5-v1', name: 'Tulipeia Femenina', price: 50, description: 'Ramo de tulipanes que celebran la feminidad.', category: 'Ramos Temáticos', features: ['Tulipanes de Calidad', 'Lazo de Seda'], imageUrl: '/assets/products/video1/5.avif' },
  { id: '6-v1', name: 'Blion Vibrante', price: 50, description: 'Energía y fuerza capturadas en un azul único.', category: 'Significado', features: ['Azul Cobalto', 'Diseño Único'], imageUrl: '/assets/products/video1/6.avif' },
  { id: '7-v1', name: 'Peadas Sutil', price: 48, description: 'Sutileza y fuerza en un ramo tejido a mano.', category: 'Artesanía', features: ['Detalles Finos', 'Duradero'], imageUrl: '/assets/products/video1/7.avif' },
  { id: '8-v1', name: 'Lioner Esencial', price: 45, description: 'Belleza simple que resalta. Elegante y accesible.', category: 'Esencial', features: ['Minimalismo', 'Calidad 3C'], imageUrl: '/assets/products/video1/8.avif' },
  { id: '9-v1', name: 'Macetas de Vida', price: 35, description: 'Frescura eterna para decorar el hogar.', category: 'Decoración', features: ['Base Artesanal', 'No requiere agua'], imageUrl: '/assets/products/video1/9.avif' },
  { id: '10-v1', name: 'Detalle Dea', price: 18, description: 'Un detalle de una sola flor con gran significado.', category: 'Detalles Rápidos', features: ['Individual', 'Eterno'], imageUrl: '/assets/products/video1/10.avif' },
  { id: '11-v1', name: 'Multi-Esencia', price: 15, description: 'Presentación alegre y multicolor. Un gesto dulce.', category: 'Detalles Rápidos', features: ['Colorido', 'Compacto'], imageUrl: '/assets/products/video1/11.avif' }
];

// --- VIDEO 2: RAMOS COMBINADOS (14 ÍTEMS) ---
const VIDEO2_PRODUCTS: Product[] = [
  { id: 'v2-1', name: 'Lirio Premium', price: 10, description: '1 lirio premium hecho a mano.', category: 'Flores de Limpiapipas', features: ['Papel coreano', 'Dedicatoria'], imageUrl: '/assets/products/video2/lirio.avif' },
  { id: 'v2-2', name: 'Lirio con Margaritas', price: 20, description: '1 lirio premium, 2 margaritas y follaje.', category: 'Ramos Especiales', features: [], imageUrl: '/assets/products/video2/lirio_margaritas.avif' },
  { id: 'v2-3', name: 'Girasol y Margaritas', price: 20, description: '1 girasol premium, 2 margaritas y follaje.', category: 'Ramos Especiales', features: ['Embolsado', 'Lazo'], imageUrl: '/assets/products/video2/girasol_margaritas.avif' },
  { id: 'v2-4', name: 'Tulipán y Margaritas', price: 20, description: '1 tulipán premium, 2 margaritas y follaje.', category: 'Ramos Especiales', features: ['Papel', 'Lazo'], imageUrl: '/assets/products/video2/tulipan_margaritas.avif' },
  { id: 'v2-5', name: 'Girasol, Tulipán y Margaritas', price: 30, description: 'Mix premium con mariposa.', category: 'Ramos Premium', features: ['Mariposa', 'Follaje'], imageUrl: '/assets/products/video2/girasol_tulipan_margaritas.avif' },
  { id: 'v2-6', name: 'Lirio y Tulipán', price: 20, description: '1 lirio y 1 tulipán premium con mariposa.', category: 'Ramos Especiales', features: ['Minimalista'], imageUrl: '/assets/products/video2/lirio_tulipan.avif' },
  { id: 'v2-7', name: '3 Lirios', price: 40, description: '3 lirios premium con follaje.', category: 'Ramos Premium', features: ['Mariposa', 'Papel coreano'], imageUrl: '/assets/products/video2/3_lirios.avif' },
  { id: 'v2-8', name: '1 Lirio y 2 Tulipanes', price: 55, description: 'Ramo Esplendor completo.', category: 'Ramos Premium', features: ['6 margaritas', 'Mariposa'], imageUrl: '/assets/products/video2/1_lirio_2_tulipanes.avif' },
  { id: 'v2-9', name: '6 Tulipanes con Luces', price: 70, description: '6 tulipanes premium con luces LED.', category: 'Detalles con Luz', features: ['Luces LED', 'Mariposa'], imageUrl: '/assets/products/video2/6_tulipanes_luces.avif' },
  { id: 'v2-10', name: '8 Tulipanes', price: 75, description: '8 tulipanes premium con 2 fotos.', category: 'Ramos de Tulipanes', features: ['Elegancia', 'Personalizable'], imageUrl: '/assets/products/video2/8_tulipanes.avif' },
  { id: 'v2-11', name: '10 Tulipanes y Margaritas', price: 100, description: 'Máximo volumen y elegancia.', category: 'Ramos Premium', features: ['10 tulipanes', '6 margaritas'], imageUrl: '/assets/products/video2/10_tulipanes_margaritas.avif' },
  { id: 'v2-12', name: '6 Girasoles', price: 80, description: '6 girasoles y margaritas con luces.', category: 'Detalles con Luz', features: ['Luces LED', 'Vibrante'], imageUrl: '/assets/products/video2/6_girasoles.avif' },
  // { id: 'v2-13', name: '4 Lirios y Peluche', price: 80, description: 'Combo ternura con 4 lirios.', category: 'Combos con Peluche', features: ['Peluche', '2 fotos'], imageUrl: 'https://images.unsplash.com/photo-1548610762-658252250269?q=80&w=800' },
  // { id: 'v2-14', name: '2 Lirios y 9 Margaritas', price: 60, description: 'Combo con peluche mediano.', category: 'Combos con Peluche', features: ['Peluche incluido'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' }
];

// --- VIDEO 3: COLECCIÓN RAMOS MAMÁ (23 ÍTEMS) ---
const VIDEO3_PRODUCTS: Product[] = [
  { id: 'v3-1', name: 'Toque de Dulzura', price: 25, description: '1 tulipán, 3 mini margaritas.', category: 'Ramos Mamá', features: ['Papel coreano'], imageUrl: '/assets/products/video3/toque_dulzura.avif' },
  { id: 'v3-2', name: 'Violeta Love', price: 28, description: '1 lirio, 1 tulipán.', category: 'Ramos Mamá', features: ['Violeta', 'Lazo'], imageUrl: '/assets/products/video3/violeta_love_converted.avif' },
  { id: 'v3-3', name: 'Rayito de Sol', price: 30, description: '1 girasol, 8 mini margaritas.', category: 'Ramos Mamá', features: ['Papel craft'], imageUrl: '/assets/products/video3/rayito_sol.avif' },
  { id: 'v3-4', name: 'Sueño de Verano', price: 38, description: '1 lirio, 3 tulipanes, 4 mini margaritas.', category: 'Ramos Mamá', features: ['Vibrante'], imageUrl: '/assets/products/video3/sueno_verano.avif' },
  { id: 'v3-5', name: 'Ternura', price: 38, description: '3 lirios, 10 mini margaritas.', category: 'Ramos Mamá', features: ['Elegante'], imageUrl: '/assets/products/video3/ternura.avif' },
  { id: 'v3-6', name: 'Dulzura', price: 45, description: '6 gerberas en tonos rosa.', category: 'Ramos Mamá', features: ['Papel coreano'], imageUrl: '/assets/products/video3/dulzura.avif' },
  { id: 'v3-7', name: 'Princesa', price: 55, description: '7 tulipanes, 9 mini margaritas.', category: 'Ramos Mamá', features: ['Lujo'], imageUrl: '/assets/products/video3/princesa.avif' },
  { id: 'v3-8', name: 'Amor Eterno', price: 65, description: '5 rosas, 4 mini margaritas.', category: 'Ramos Mamá', features: ['Premium'], imageUrl: '/assets/products/video3/amor_eterno.avif' },
  { id: 'v3-9', name: 'Corazón', price: 68, description: '6 tulipanes, 2 lirios.', category: 'Ramos Mamá', features: ['Empaque negro'], imageUrl: '/assets/products/video3/corazon.avif' },
  // { id: 'v3-10', name: 'Extravaganza', price: 120, description: '14 tulipanes, 5 lirios.', category: 'Ramos Mamá', features: ['El más grande'], imageUrl: '/assets/products/video3/extravaganza.avif' },
  { id: 'v3-11', name: 'Evangeline', price: 80, description: '12 tulipanes, 2 lirios con luces.', category: 'Ramos Mamá', features: ['Con luces'], imageUrl: '/assets/products/video3/evangeline.avif' },
  { id: 'v3-12', name: 'Notas de Amor', price: 80, description: '12 gerberas y mariposa.', category: 'Ramos Mamá', features: ['Artesanal'], imageUrl: '/assets/products/video3/notas_amor.avif' },
  { id: 'v3-m1', name: 'Mini Girasol Maceta', price: 20, description: 'Con capullo.', category: 'Macetitas', features: ['20 soles'], imageUrl: '/assets/products/video3/mini_girasol.avif' },
  { id: 'v3-m2', name: 'Mini Gerbera Maceta', price: 20, description: 'Con 2 capullos.', category: 'Macetitas', features: ['20 soles'], imageUrl: '/assets/products/video3/mini_gerbera.avif' },
  // { id: 'v3-m3', name: 'Mini Loto Maceta', price: 28, description: 'Elegante.', category: 'Macetitas', features: ['28 soles'], imageUrl: '/assets/products/video3/mini_loto.avif' },
  { id: 'v3-m4', name: 'Mini Tulipanes Maceta', price: 18, description: '7 mini tulipanes.', category: 'Macetitas', features: ['18 soles'], imageUrl: '/assets/products/video3/mini_tulipanes.avif' },
  { id: 'v3-m5', name: 'Mini Margaritas Maceta', price: 18, description: '7 mini margaritas.', category: 'Macetitas', features: ['18 soles'], imageUrl: '/assets/products/video3/mini_margaritas.avif' },
  // { id: 'v3-m6', name: 'Mini Campanitas Maceta', price: 22, description: '6 campanitas.', category: 'Macetitas', features: ['22 soles'], imageUrl: '/assets/products/video3/mini_campanitas_maceta.avif' },
  // { id: 'v3-acc1', name: 'Coronita Pequeña', price: 10, description: 'Accesorio.', category: 'Accesorios', features: ['Dorado/Plata'], imageUrl: '/assets/products/video3/coronita_pequena.avif' },
  // { id: 'v3-acc2', name: 'Globo Personalizado', price: 8, description: 'Mensaje.', category: 'Accesorios', features: ['8 soles'], imageUrl: '/assets/products/video3/globo_personalizado.avif' },
  // { id: 'v3-acc3', name: 'Luces LED', price: 5, description: 'Tira.', category: 'Accesorios', features: ['5 soles'], imageUrl: '/assets/products/video3/luces_led.avif' },
  // { id: 'v3-acc4', name: 'Bombones Ferrero', price: 4, description: 'Chocolate.', category: 'Accesorios', features: ['4 soles'], imageUrl: '/assets/products/video3/bombones_ferrero.avif' },
  // { id: 'v3-acc5', name: 'Mariposa Calada', price: 1.5, description: 'Adorno.', category: 'Accesorios', features: ['1.50 soles'], imageUrl: '/assets/products/video3/mariposa_calada.avif' }
];

// --- VIDEO 4: UNIDADES Y COLECCIONES (39 ÍTEMS) ---
const VIDEO4_PRODUCTS: Product[] = [
  { id: 'v4-1', name: 'Lirio Unidad', price: 8, description: 'Unidad.', category: 'Unidades', features: ['8 soles'], imageUrl: '/assets/products/video4/lirio.avif' },
  { id: 'v4-2', name: 'Tulipán Unidad', price: 6, description: 'Unidad.', category: 'Unidades', features: ['6 soles'], imageUrl: '/assets/products/video4/tulipan.avif' },
  { id: 'v4-3', name: 'Girasol Unidad', price: 10, description: 'Unidad.', category: 'Unidades', features: ['10 soles'], imageUrl: '/assets/products/video4/girasol.avif' },
  // { id: 'v4-4', name: 'Anturio Unidad', price: 6, description: 'Unidad.', category: 'Unidades', features: ['6 soles'], imageUrl: '/assets/products/video4/anturio.avif' },
  { id: 'v4-5', name: 'Margarita Unidad', price: 6, description: 'Unidad.', category: 'Unidades', features: ['6 soles'], imageUrl: '/assets/products/video4/margarita.avif' },
  { id: 'v4-6', name: 'Rosa Unidad', price: 10, description: 'Unidad.', category: 'Unidades', features: ['10 soles'], imageUrl: '/assets/products/video4/rosa.avif' },
  // { id: 'v4-7', name: 'Flor de Loto Unidad', price: 12, description: 'Unidad.', category: 'Unidades', features: ['12 soles'], imageUrl: '/assets/products/video4/loto.avif' },
  // { id: 'v4-8', name: 'Hortensia Unidad', price: 12, description: 'Unidad.', category: 'Unidades', features: ['12 soles'], imageUrl: 'https://images.unsplash.com/photo-1444930694458-01babf71870c?q=80&w=800' },
  // { id: 'v4-9', name: 'Orquídea Unidad', price: 6, description: 'Unidad.', category: 'Unidades', features: ['6 soles'], imageUrl: 'https://images.unsplash.com/photo-1485955900006-10f4d324d411?q=80&w=800' },
  { id: 'v4-10', name: 'Ramo Lirio y Margarita', price: 8, description: 'Ramo.', category: 'Ramos', features: ['8 soles'], imageUrl: '/assets/products/video4/lirio_margarita.avif' },
  { id: 'v4-11', name: 'Ramo Lirio y Margaritas', price: 16, description: 'Ramo.', category: 'Ramos', features: ['16 soles'], imageUrl: '/assets/products/video4/lirios_margaritas.avif' },
  { id: 'v4-12', name: 'Ramo Tulipanes y Margaritas', price: 25, description: 'Ramo.', category: 'Ramos', features: ['25 soles'], imageUrl: '/assets/products/video4/tulipanes_margaritas.avif' },
  { id: 'v4-13', name: 'Ramo Girasol y Margaritas', price: 20, description: 'Ramo.', category: 'Ramos', features: ['20 soles'], imageUrl: '/assets/products/video4/girasol_margaritas.avif' },
  { id: 'v4-14', name: 'Ramo Tulipanes y un Lirio', price: 20, description: 'Ramo.', category: 'Ramos', features: ['20 soles'], imageUrl: '/assets/products/video4/ramo_tulipanes_lirios.avif' },
  { id: 'v4-15', name: 'Ramo Lirio y Tulipanes', price: 20, description: 'Ramo.', category: 'Ramos', features: ['20 soles'], imageUrl: '/assets/products/video4/ramo_lirio_tulipanes.avif' },
  { id: 'v4-16', name: 'Ramo Dos Tulipanes', price: 12, description: 'Ramo.', category: 'Ramos', features: ['12 soles'], imageUrl: '/assets/products/video4/duo_tulipanes.avif' },
  { id: 'v4-17', name: 'Ramo Girasol y Margaritas B', price: 15, description: 'Ramo.', category: 'Ramos', features: ['15 soles'], imageUrl: '/assets/products/video4/girasol_margaritas.avif' },
  // { id: 'v4-18', name: 'Ramo Anturios y Rosas', price: 20, description: 'Ramo.', category: 'Mini Ramos', features: ['20 soles'], imageUrl: '/assets/products/video4/anturios_rosas.avif' },
  { id: 'v4-19', name: 'Ramo de Tulipanes', price: 40, description: 'Ramo.', category: 'Ramos', features: ['40 soles'], imageUrl: '/assets/products/video4/ramo_tulipanes.avif' },
  { id: 'v4-20', name: 'Ramo de Girasoles', price: 55, description: 'Ramo.', category: 'Ramos', features: ['55 soles'], imageUrl: '/assets/products/video4/ramo_girasoles.avif' },
  // { id: 'v4-21', name: 'Ramo Van Gogh', price: 45, description: 'Ramo.', category: 'Ramos', features: ['45 soles'], imageUrl: '/assets/products/video4/ramo_van_gogh.avif' },
  // { id: 'v4-22', name: 'Ramo de Anturio', price: 45, description: 'Ramo.', category: 'Ramos', features: ['45 soles'], imageUrl: '/assets/products/video4/ramo_anturio.avif' },
  { id: 'v4-23', name: 'Ramo de 2 Lirios y Tulipanes', price: 40, description: 'Ramo.', category: 'Ramos', features: ['40 soles'], imageUrl: '/assets/products/video4/ramo_2_lirios_tulipanes.avif' },
  // { id: 'v4-24', name: 'Ramo Dulce Fragancia', price: 25, description: 'Ramo.', category: 'Ramos', features: ['25 soles'], imageUrl: '/assets/products/video4/ramo_dulce_fragancia.avif' },
  { id: 'v4-25', name: 'Bouquet de Margaritas', price: 40, description: 'Ramo.', category: 'Ramos', features: ['40 soles'], imageUrl: '/assets/products/video4/bouquet_margaritas.avif' },
  { id: 'v4-26', name: 'Bouquet Rosita', price: 45, description: 'Ramo.', category: 'Ramos', features: ['45 soles'], imageUrl: '/assets/products/video4/bouquet_rosita.avif' },
  // { id: 'v4-27', name: 'Ramo Jardin Secreto', price: 60, description: 'Ramo.', category: 'Ramos', features: ['60 soles'], imageUrl: '/assets/products/video4/ramo_jardin_secreto.avif' },
  { id: 'v4-28', name: 'Princesa Rapunzel', price: 30, description: 'Princesa.', category: 'Princesas', features: ['30 soles'], imageUrl: '/assets/products/video4/princesa_rapunzel.avif' },
  // { id: 'v4-29', name: 'Princesa Cenicienta', price: 18, description: 'Princesa.', category: 'Princesas', features: ['18 soles'], imageUrl: '/assets/products/video4/princesa_cenicienta.avif' },
  // { id: 'v4-30', name: 'Princesa Aurora', price: 18, description: 'Princesa.', category: 'Princesas', features: ['18 soles'], imageUrl: '/assets/products/video4/princesa_aurora.avif' },
  // { id: 'v4-31', name: 'Princesa Bella', price: 18, description: 'Princesa.', category: 'Princesas', features: ['18 soles'], imageUrl: '/assets/products/video4/princesa_bella.avif' },
  // { id: 'v4-32', name: 'Princesa Blancanieves', price: 18, description: 'Princesa.', category: 'Princesas', features: ['18 soles'], imageUrl: '/assets/products/video4/princesa_blancanieves.avif' },
  // { id: 'v4-33', name: 'Combo Princesas', price: 190, description: 'Mega combo.', category: 'Princesas', features: ['190 soles'], imageUrl: '/assets/products/video4/combo_princesas.avif' },
  // { id: 'v4-34', name: 'Rosita Fresita', price: 35, description: 'Personaje.', category: 'Personajes', features: ['35 soles'], imageUrl: '/assets/products/video4/rosita_fresita.avif' },
  // { id: 'v4-35', name: 'Hello Kitty', price: 35, description: 'Personaje.', category: 'Personajes', features: ['35 soles'], imageUrl: '/assets/products/video4/hello_kitty.avif' },
  // { id: 'v4-36', name: 'Snoopy', price: 55, description: 'Personaje.', category: 'Personajes', features: ['55 soles'], imageUrl: '/assets/products/video4/snoopy.avif' },
  // { id: 'v4-37', name: 'Spiderman', price: 40, description: 'Personaje.', category: 'Personajes', features: ['40 soles'], imageUrl: '/assets/products/video4/spiderman.avif' },
  // { id: 'v4-38', name: 'Kuromi', price: 35, description: 'Personaje.', category: 'Personajes', features: ['35 soles'], imageUrl: '/assets/products/video4/kuromi.avif' },
  // { id: 'v4-39', name: 'Rayo McQueen', price: 40, description: 'Personaje.', category: 'Personajes', features: ['40 soles'], imageUrl: '/assets/products/video4/rayo_mcqueen.avif' }
];

// --- VIDEO 5: COLECCIÓN DONATELLO (27 ÍTEMS) ---
const VIDEO5_PRODUCTS: Product[] = [
  { id: 'v5-1', name: 'Flores a tu Elección', price: 12, description: 'Flor con fondo decorativo.', category: 'Personalizados', features: ['S/ 12'], imageUrl: '/assets/products/video5/flores_eleccion.avif' },
  { id: 'v5-2', name: 'Ramo Girasol 45cm', price: 35, description: 'Girasol premium.', category: 'Ramos Girasol', features: ['45cm alto'], imageUrl: '/assets/products/video5/girasol.avif' },
  { id: 'v5-3', name: 'Lirio Ondeado', price: 15, description: 'Bordes ondeados.', category: 'Arreglos', features: ['Fondo cartón'], imageUrl: '/assets/products/video5/lirio_ondeado.avif' },
  { id: 'v5-4', name: 'Tulipán Individual', price: 15, description: '1 Tulipán premium.', category: 'Arreglos', features: ['Papel coreano'], imageUrl: '/assets/products/video5/tulipan_individual.avif' },
  { id: 'v5-5', name: 'Ramo Milly', price: 25, description: '1 lirio, 3 margaritas.', category: 'Ramos Ella', features: ['Artesanal'], imageUrl: '/assets/products/video5/ramo_milly.avif' },
  { id: 'v5-6', name: 'Ramo Nora', price: 28, description: 'Tulipán y lirio.', category: 'Ramos Ella', features: ['Elegante'], imageUrl: '/assets/products/video5/ramo_nora.avif' },
  { id: 'v5-7', name: 'Girasol Mediano', price: 20, description: '1 girasol con lazo.', category: 'Arreglos', features: ['Vibrante'], imageUrl: '/assets/products/video5/girasol_mediano.avif' },
  { id: 'v5-8', name: 'Lirio Mediano', price: 18, description: '1 lirio y margarita.', category: 'Arreglos', features: ['Fino'], imageUrl: '/assets/products/video5/lirio_mediano.avif' },
  { id: 'v5-9', name: 'Ramo Camilla', price: 25, description: 'Lirio ondeado.', category: 'Ramos Ella', features: ['Lazo decorativo'], imageUrl: '/assets/products/video5/ramo_camilla.avif' },
  { id: 'v5-10', name: 'Ramo Alva', price: 35, description: '1 lirio, 4 margaritas.', category: 'Ramos Ella', features: ['Lazo premium'], imageUrl: '/assets/products/video5/ramo_alva.avif' },
  { id: 'v5-11', name: 'Ramo Amara', price: 33, description: 'Mix floral 3C.', category: 'Ramos Ella', features: ['Prestigio'], imageUrl: '/assets/products/video5/ramo_amara.avif' },
  { id: 'v5-12', name: 'Ramo Piscis', price: 28, description: 'Lirio y tulipán.', category: 'Ramos Ella', features: ['Económico'], imageUrl: '/assets/products/video5/ramo_piscis.avif' },
  { id: 'v5-13', name: 'Ramo Emily', price: 58, description: '5 tulipanes azul.', category: 'Ramos Ella', features: ['Azul Cobalto'], imageUrl: '/assets/products/video5/ramo_emily.avif' },
  { id: 'v5-14', name: 'Ramo Love', price: 40, description: '3 tulipanes y margaritas.', category: 'Ramos Ella', features: ['Lazo rojo'], imageUrl: '/assets/products/video5/ramo_love.avif' },
  // { id: 'v5-15', name: 'Ramo Gitana', price: 50, description: 'Doble color.', category: 'Ramos Ella', features: ['Personalizable'], imageUrl: '/assets/products/video5/ramo_gitana.avif' },
  { id: 'v5-16', name: 'Ramo Sofia', price: 40, description: '3 tulipanes, 1 lirio.', category: 'Ramos Ella', features: ['Completo'], imageUrl: '/assets/products/video5/ramo_sofia.avif' },
  { id: 'v5-17', name: 'Ramo Tulipanes 7', price: 70, description: 'Lujo artesanal.', category: 'Ramos Ella', features: ['9 margaritas'], imageUrl: '/assets/products/video5/ramo_tulipanes.avif' },
  { id: 'v5-18', name: 'Ramo Alessia', price: 65, description: '3 rosas, 1 girasol.', category: 'Ramos Ella', features: ['Mix premium'], imageUrl: '/assets/products/video5/ramo_alessia.avif' },
  { id: 'v5-m1', name: 'Maceta Mini Girasoles', price: 20, description: '6 mini girasoles.', category: 'Macetas', features: ['15cm alto'], imageUrl: '/assets/products/video5/maceta_mini_girasoles.avif' },
  { id: 'v5-m2', name: 'Maceta Mini Tulipán', price: 15, description: '6 tulipanes.', category: 'Macetas', features: ['Colorido'], imageUrl: '/assets/products/video5/maceta_mini_tulipanes.avif' },
  { id: 'v5-m3', name: 'Maceta Mini Margaritas', price: 26, description: 'Mix margaritas.', category: 'Macetas', features: ['25cm alto'], imageUrl: '/assets/products/video5/maceta_mini_margaritas.avif' },
  // { id: 'v5-m4', name: 'Maceta Corazón', price: 22, description: 'Porta lapiceros.', category: 'Macetas', features: ['Funcional'], imageUrl: '/assets/products/video5/maceta_corazon.avif' },
  // { id: 'v5-acc1', name: 'Luces LED Extra', price: 4.50, description: 'Tira de luces.', category: 'Extras', features: ['Cálidas'], imageUrl: '/assets/products/video5/luces_led.avif' },
  // { id: 'v5-acc2', name: 'Foto Extra', price: 2.50, description: 'Personalizado.', category: 'Extras', features: ['Foto'], imageUrl: '/assets/products/video5/foto_extra.avif' },
  // { id: 'v5-acc3', name: 'Florero Polipropileno', price: 13, description: 'Resistente.', category: 'Extras', features: ['Irrompible'], imageUrl: '/assets/products/video5/florero.avif' },
  // { id: 'v5-acc4', name: 'Porta maceta cartón', price: 5, description: 'Empaque.', category: 'Extras', features: ['Práctico'], imageUrl: '/assets/products/video5/porta_maceta.avif' },
  // { id: 'v5-acc5', name: 'Sujetador Corazón', price: 2.50, description: 'Metal.', category: 'Extras', features: ['Forma corazón'], imageUrl: '/assets/products/video5/sujetador_corazon.avif' }
];

// --- VIDEO 6: RAMOS PERSONALIZADOS (15 ÍTEMS) ---
const VIDEO6_PRODUCTS: Product[] = [
  { id: 'v6-1', name: 'Lirio', price: 5, description: 'Individual.', category: 'Económicos', features: ['S/ 5.00'], imageUrl: '/assets/products/video6/lirio.avif' },
  { id: 'v6-2', name: 'Tulipán', price: 7, description: 'Individual.', category: 'Económicos', features: ['S/ 7.00'], imageUrl: '/assets/products/video6/tulipan.avif' },
  { id: 'v6-3', name: 'Girasol', price: 8, description: 'Individual.', category: 'Económicos', features: ['S/ 8.00'], imageUrl: '/assets/products/video6/girasol.avif' },
  { id: 'v6-4', name: 'Dúo 2 Tulipanes', price: 12, description: 'Mini ramo.', category: 'Mini Ramos', features: ['12 soles'], imageUrl: '/assets/products/video6/duo_tulipanes.avif' },
  // { id: 'v6-5', name: 'Margarita y Tulipán', price: 14, description: 'Mini ramo.', category: 'Mini Ramos', features: ['14 soles'], imageUrl: '/assets/products/video6/margarita_tulipan.avif' },
  { id: 'v6-6', name: 'Espiral Mix', price: 11, description: 'Mini ramo.', category: 'Mini Ramos', features: ['11 soles'], imageUrl: '/assets/products/video6/espiral.avif' },
  { id: 'v6-7', name: 'Ternura Mix', price: 19, description: 'Ramo mediano.', category: 'Ramos Medianos', features: ['19 soles'], imageUrl: '/assets/products/video6/ternura_mix.avif' },
  { id: 'v6-8', name: 'Eucalipto Mix', price: 21, description: 'Ramo mediano.', category: 'Ramos Medianos', features: ['21 soles'], imageUrl: '/assets/products/video6/eucalipto_mix.avif' },
  // { id: 'v6-9', name: 'Spider-man 3C', price: 19, description: 'Temático.', category: 'Personajes', features: ['Exclusivo'], imageUrl: '/assets/products/video6/spider_man.avif' },
  { id: 'v6-10', name: 'Solar Mix', price: 26, description: '3 girasoles.', category: 'Ramos Grandes', features: ['26 soles'], imageUrl: '/assets/products/video6/solar_mix.avif' },
  { id: 'v6-11', name: 'Lirio Floral 4M', price: 15, description: 'Ramo mediano.', category: 'Ramos Medianos', features: ['15 soles'], imageUrl: '/assets/products/video6/lirio_floral.avif' },
  { id: 'v6-12', name: 'Triple Dúo', price: 29, description: '3 Tulipanes, 3 Lirios.', category: 'Ramos Grandes', features: ['29 soles'], imageUrl: '/assets/products/video6/triple_duo.avif' },
  { id: 'v6-13', name: 'Mega Bouquet 30M', price: 40, description: '30 Margaritas.', category: 'Colección Especial', features: ['40 soles'], imageUrl: '/assets/products/video6/mega_bouquet.avif' },
  { id: 'v6-14', name: 'Bouquet 12 Tulipanes', price: 66, description: 'Docena.', category: 'Ramos Tulipanes', features: ['66 soles'], imageUrl: '/assets/products/video6/bouquet_12_tulipanes.avif' },
  // { id: 'v6-15', name: 'Master Mix 3C', price: 60, description: 'Full variado.', category: 'Colección Especial', features: ['60 soles'], imageUrl: '/assets/products/video6/master_mix.avif' }
];

// --- VIDEO 7: ESPECIAL FIORE D' AMORE (44 ÍTEMS) ---
const VIDEO7_PRODUCTS: Product[] = [
  // --- GIRASOLES ---
  { id: 'v7-1', name: 'Sol en Flor', price: 7, description: '1 Girasol M, 3 hojitas.', category: 'Girasoles', features: ['S/ 7.00'], imageUrl: 'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=800' },
  { id: 'v7-2', name: 'Rayitos de Sol', price: 13, description: '2 Girasoles M.', category: 'Girasoles', features: ['S/ 13.00'], imageUrl: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?q=80&w=800' },
  { id: 'v7-3', name: 'Jardín Solar', price: 28, description: '6 Girasoles M.', category: 'Girasoles', features: ['S/ 28.00'], imageUrl: 'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=800' },
  { id: 'v7-4', name: 'Sol de Primavera', price: 23, description: '1 Girasol M, 4 Girasoles S.', category: 'Girasoles', features: ['S/ 23.00'], imageUrl: 'https://images.unsplash.com/photo-1444930694458-01babf71870c?q=80&w=800' },
  { id: 'v7-5', name: 'Trilogía Floral', price: 24, description: '3 Girasoles M, 3 Lirios.', category: 'Mix Floral', features: ['S/ 24.00'], imageUrl: 'https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?q=80&w=800' },
  { id: 'v7-6', name: 'Instante Dorado', price: 13, description: '1 Girasol L, mariposa.', category: 'Girasoles', features: ['S/ 13.00'], imageUrl: 'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=800' },
  { id: 'v7-7', name: 'Golden Hour', price: 45, description: '10 Girasoles M.', category: 'Girasoles', features: ['S/ 45.00'], imageUrl: 'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=800' },
  { id: 'v7-8', name: 'Armonía Floral', price: 30, description: '4 Girasoles M, 4 Lirios.', category: 'Mix Floral', features: ['S/ 30.00'], imageUrl: 'https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?q=80&w=800' },
  // --- TULIPANES ---
  { id: 'v7-9', name: 'Esencia', price: 6, description: '1 Tulipán, 3 mini margaritas.', category: 'Tulipanes', features: ['S/ 6.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-10', name: 'Eterna Primavera', price: 52, description: '18 Tulipanes.', category: 'Tulipanes', features: ['S/ 52.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-11', name: 'Amor en Pétalos', price: 22, description: '8 Tulipanes.', category: 'Tulipanes', features: ['S/ 22.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-12', name: 'Tres en Flor', price: 13, description: '3 Tulipanes, 5 mini margaritas.', category: 'Tulipanes', features: ['S/ 13.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-13', name: 'Media Primavera', price: 18, description: '6 Tulipanes, 6 mini margaritas.', category: 'Tulipanes', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-14', name: 'Ilusión Floral', price: 15, description: '4 Tulipanes, nubecitas.', category: 'Tulipanes', features: ['S/ 15.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-15', name: 'Entre Flores', price: 25, description: '5 Tulipanes, 1 Lirio.', category: 'Tulipanes', features: ['S/ 25.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  { id: 'v7-16', name: 'Primavera Máxima', price: 35, description: '12 Tulipanes.', category: 'Tulipanes', features: ['S/ 35.00'], imageUrl: 'https://images.unsplash.com/photo-1520323232435-5882ad34f7ae?q=80&w=800' },
  // --- LIRIOS ---
  { id: 'v7-17', name: 'Aura Floral', price: 6, description: '1 Lirio, 1 mini margarita.', category: 'Lirios', features: ['S/ 6.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-18', name: 'Lilium Realista', price: 10, description: '1 Lirio, 1 tulipán.', category: 'Lirios', features: ['S/ 10.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-19', name: 'Cinco en Flor', price: 25, description: '5 Lirios.', category: 'Lirios', features: ['S/ 25.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-20', name: 'Alma en Lirio', price: 35, description: '4 Lirios, 3 mini margaritas.', category: 'Lirios', features: ['S/ 35.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-21', name: 'Triple Encanto', price: 6, description: '3 Lirios.', category: 'Lirios', features: ['S/ 6.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-22', name: 'Esencia Floral Master', price: 37, description: '7 Lirios.', category: 'Lirios', features: ['S/ 37.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-23', name: 'Un Instante Lirio', price: 25, description: '1 Lirio, 4 mini margaritas.', category: 'Lirios', features: ['S/ 25.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  { id: 'v7-24', name: 'Armonía Lirios', price: 35, description: '6 Lirios.', category: 'Lirios', features: ['S/ 35.00'], imageUrl: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?q=80&w=800' },
  // --- GERBERAS ---
  { id: 'v7-25', name: 'Destello Gerbera', price: 6, description: '1 Gerbera.', category: 'Gerberas', features: ['S/ 6.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-26', name: 'Tres Destellos Gerberas', price: 18, description: '3 Gerberas.', category: 'Gerberas', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-27', name: 'Amor y Gerberas', price: 18, description: '5 Gerberas.', category: 'Gerberas', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-28', name: 'Spring Gerberas', price: 32, description: '6 Gerberas, 6 tulipanes.', category: 'Gerberas', features: ['S/ 32.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-29', name: 'Abundancia Gerbera', price: 55, description: '18 Gerberas.', category: 'Gerberas', features: ['S/ 55.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-30', name: 'Florecer Gerberas', price: 18, description: '6 Gerberas.', category: 'Gerberas', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-31', name: 'Trilogía Amor', price: 11, description: '3 Gerberas.', category: 'Gerberas', features: ['S/ 11.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-32', name: 'Primaveral Gerbera', price: 32, description: '7 Gerberas.', category: 'Gerberas', features: ['S/ 32.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  // --- OTROS ---
  { id: 'v7-33', name: 'Cielo en Flores Margaritas', price: 13, description: '24 mini.', category: 'Margaritas', features: ['S/ 13.00'], imageUrl: 'https://images.unsplash.com/photo-1494972308805-463bc619d34e?q=80&w=800' },
  { id: 'v7-34', name: 'Mini Primavera M', price: 9.5, description: '17 mini.', category: 'Margaritas', features: ['S/ 9.50'], imageUrl: 'https://images.unsplash.com/photo-1494972308805-463bc619d34e?q=80&w=800' },
  { id: 'v7-35', name: 'Plenitud M', price: 16, description: '30 mini.', category: 'Margaritas', features: ['S/ 16.00'], imageUrl: 'https://images.unsplash.com/photo-1494972308805-463bc619d34e?q=80&w=800' },
  { id: 'v7-36', name: 'Esencia en Flor M', price: 18, description: '35 mini.', category: 'Margaritas', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1494972308805-463bc619d34e?q=80&w=800' },
  { id: 'v7-37', name: 'Hibiscos Floral', price: 10, description: '2 Hibiscos.', category: 'Hibiscos', features: ['S/ 10.00'], imageUrl: 'https://images.unsplash.com/photo-1561181286-d3fea73e413f?q=80&w=800' },
  { id: 'v7-38', name: 'Hibiscos Paraíso', price: 23, description: '7 Hibiscos.', category: 'Hibiscos', features: ['S/ 23.00'], imageUrl: 'https://images.unsplash.com/photo-1561181286-d3fea73e413f?q=80&w=800' },
  { id: 'v7-39', name: ' Hibiscos Tropical', price: 16, description: '3 Hibiscos.', category: 'Hibiscos', features: ['S/ 16.00'], imageUrl: 'https://images.unsplash.com/photo-1561181286-d3fea73e413f?q=80&w=800' },
  { id: 'v7-40', name: 'Hibiscos Atardecer', price: 18, description: '3 Hibiscos.', category: 'Hibiscos', features: ['S/ 18.00'], imageUrl: 'https://images.unsplash.com/photo-1561181286-d3fea73e413f?q=80&w=800' },
  { id: 'v7-41', name: 'Rosa Eterna', price: 6, description: '1 Rosa.', category: 'Rosas', features: ['S/ 6.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-42', name: 'Bouquet Clasic R', price: 26, description: '6 Rosas.', category: 'Rosas', features: ['S/ 26.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-43', name: 'Amor Eterno Rosas Master', price: 35, description: '10 Rosas.', category: 'Rosas', features: ['S/ 35.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' },
  { id: 'v7-44', name: 'Romance Rosas', price: 28, description: '8 Rosas.', category: 'Rosas', features: ['S/ 28.00'], imageUrl: 'https://images.unsplash.com/photo-1591880911020-d3449a3ef011?q=80&w=800' }
];

const PRODUCTS_UNO: Product[] = [
  {
    id: 'marcoDeAmor',
    name: 'Marco de Amor',
    price: 60,
    description: 'Incluye: Cuadro de madera, Lazo y Dedicatoria.',
    category: 'Premium',
    features: [],
    imageUrl: '/assets/products/oficial/marco_de_amor.avif'
  },
  {
    id: 'domoDelDestello',
    name: 'Domo del Destello',
    category: 'Premium',
    price: 65,
    description: 'Incluye: Cápsula de acrílico, tul con perlas, 2 lirios, lazo y dedicatoria.',
    imageUrl: '/assets/products/oficial/domo_del_destello.avif',
    features: [],
  },
  {
    id: 'reflejoDeAmor',
    category: 'Arreglos',
    name: 'Reflejo de amor',
    imageUrl: '/assets/products/oficial/espejo.avif',
    price: 50,
    features: [],
    description: 'Incluye: Espejo, papel coreano, lazo y dedicatoria'
  },
  { 
    // 6 girasoles con luces
    id: 'ramoAnaLuces',
    name: 'Ramo Ana Luces',
    price: 60,
    description: 'Incluye: 6 girasoles, 10 margaritas, papel coreano, lazo, dedicatoria y luces LED.',
    category: 'Detalles con Luz',
    features: [],
    imageUrl: '/assets/products/video2/6_girasoles.avif'
  },
  {
    // 1 lirio ondeado, 2 margaritas y 2 eucaliptos
    id: 'ramoCamilla',
    name: 'Ramo Camilla',
    price: 20,
    description: 'Incluye: 1 lirio ondeado, 1 margarita y 2 eucaliptos, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video5/ramo_camilla.avif'
  },
  {
    // 1 Lirio, 2 margaritas y 1 eucalipto
    id: 'auraLavanda',
    price: 20,
    category: 'Ramos Especiales',
    name: 'Aura de Lavanda',
    features: [],
    imageUrl: '/assets/products/video2/lirio_margaritas.avif',
    description: 'Incluye: 1 Lirio, 2 margaritas y 1 eucalipto, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 lirio, 4 margaritas y 2 eucaliptos
    id: 'encantoRosado',
    name: 'Encanto Rosado',
    price: 23,
    description: 'Incluye: 1 lirio, 4 margaritas y 2 eucaliptos, papel coreano, lazo y dedicatoria',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video4/lirios_margaritas.avif'
  },
  {
    // 1 Girasol, 2 margaritas y 1 eucalipto
    id: 'susurroSol',
    price: 20,
    category: 'Ramos Especiales',
    name: 'Susurro de Sol',
    features: [],
    imageUrl: '/assets/products/video1/1.avif',
    description: 'Incluye: 1 Girasol, 2 margaritas y 1 eucalipto, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 tulipán, 2 margaritas, 1 eucalipto
    id: 'toqueDulzura',
    price: 25,
    category: 'Ramos Especiales',
    name: 'Toque de Dulzura',
    features: [],
    imageUrl: '/assets/products/video3/toque_dulzura.avif',
    description: 'Incluye: 1 tulipán, 2 margaritas y 1 eucalipto, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 girasol, 8 mini margaritas
    id: 'rayitoSol',
    price: 35,
    category: 'Ramos Especiales',
    name: 'Rayito de Sol',
    features: [],
    imageUrl: '/assets/products/video3/rayito_sol.avif',
    description: 'Incluye: 1 girasol, 8 margaritas, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 lirio, 3 margaritas y 4 gusanitos
    id: 'ramoMilly',
    name: 'Ramo Milly',
    price: 18,
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video5/ramo_milly.avif',
    description: 'Incluye: 1 lirio, 3 margaritas y 4 gusanitos, papel coreano, lazo y dedicatoria'
  }
]

const PRODUCTS_DOS: Product[] = [
  {
    // 1 Lirio y 1 tulipán premium
    id: 'lirioTulipan',
    price: 25,
    category: 'Ramos Especiales',
    name: 'Dulce Romance',
    features: [],
    imageUrl: '/assets/products/video2/lirio_tulipan.avif',
    description: 'Incluye: 1 lirio y 1 tulipán premium, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 Girasol, 1 Tulipán y 2 Margaritas
    id: 'albaRadiante',
    price: 25,
    category: 'Ramos Especiales',
    name: 'Alba Radiante',
    features: [],
    imageUrl: '/assets/products/video2/girasol_tulipan_margaritas.avif',
    description: 'Incluye: 1 girasol, 1 tulipán y 2 margaritas, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 lirio, 1 tulipán, 2 margaritas
    id: 'susurroAlgodon',
    price: 28,
    category: 'Ramos Especiales',
    name: 'Susurro de Algodón',
    features: [],
    // imageUrl: '/assets/products/video3/violeta_love_converted.avif',
    imageUrl: '/assets/products/video4/lirio_margarita.avif',
    description: 'Incluye: 1 lirio, 1 tulipán, 3 margaritas, papel coreano, lazo y dedicatoria'
  },
  {
    // 2 tulipanes
    id: 'duoLavanda',
    name: 'Duo Lavanda',
    price: 22,
    category: 'Ramos Especiales',
    features: [],
    // imageUrl: '/assets/products/video4/duo_tulipanes.avif',
    imageUrl: '/assets/products/video6/duo_tulipanes.avif',
    description: 'Incluye: 2 tulipanes, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 lirio, 1 tulipán y 2 gusanitos
    id: 'ramoNora',
    name: 'Ramo Nora',
    price: 25,
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video5/ramo_nora.avif',
    description: 'Incluye: 1 lirio, 1 tulipán, 2 gusanitos, papel coreano, lazo y dedicatoria'
  },
  {
    // 1 lirio, 1 tulipán, 2 margaritas, 2 eucaliptos
    id: 'ramoAmara',
    name: 'Ramo Amara',
    price: 28,
    category: 'Ramos Especiales',
    imageUrl: '/assets/products/video5/ramo_amara.avif',
    features: [],
    description: 'Incluye: 1 lirio, 1 tulipán, 2 margaritas y 2 eucaliptos, papel coreano, lazo y dedicatoria',
  },
]

const PRODUCTS_TRES: Product[] = [
  {
    // 3 lirios 2 plantitas
    id: 'liriosAlmeda', 
    name: 'Lirios Almeda', 
    price: 28, 
    description: 'Incluye: 3 lirios, 2 plantitas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video2/3_lirios.avif' 
  },
  { 
    // 1 lirio, 2 tulipanes, 6 margaritas
    id: 'esplendorCompleto', 
    name: 'Esplendor Completo', 
    price: 28, 
    description: 'Incluye: 1 lirio, 2 tulipanes y 6 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video2/1_lirio_2_tulipanes.avif' 
  },
  { 
    // 1 lirio, 3 tulipanes, 4 mini margaritas
    id: 'suenoDeVerano', 
    name: 'Sueño de Verano', 
    price: 35, 
    description: 'Incluye: 1 lirio, 3 tulipanes y 4 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video3/sueno_verano.avif' 
  },
  { 
    // 3 lirios, 3 ramitas
    id: 'ternura', 
    name: 'Ternura', 
    price: 28, 
    description: 'Incluye: 3 lirios, 9 margaritas y 3 ramitas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video3/ternura.avif' 
  },
  { 
    // 1 lirio, tulipanes
    id: 'ramoElegancia', 
    name: 'Ramo Elegancia', 
    price: 24, 
    description: 'Incluye: 1 lirio, 2 tulipanes, 2 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video4/ramo_lirio_tulipanes.avif' 
  },
]

const PRODUCTS_MACETAS: Product[] = [
  { 
    id: 'cajitasDeAmor', 
    name: 'Cajitas de Amor', 
    price: 25, 
    description: 'Incluye: Dedicatoria.', 
    category: 'Macetas', 
    features: [], 
    available: ['Cactus', 'Girasol', 'Margarita', 'Gerbera', 'Tulipán', 'Rosa', 'Lirio'],
    imageUrl: '/assets/products/video1/3.avif' 
  },
  // {
  //   // Mini Girasol Maceta
  //   id: 'miniGirasol', 
  //   name: 'Mini Girasol Maceta', 
  //   price: 20, 
  //   description: 'Incluye: 1 girasol, capullos, dedicatoria.', 
  //   category: 'Macetitas', 
  //   features: [], 
  //   imageUrl: '/assets/products/video3/mini_girasol.avif' 
  // },
  // { 
  //   // Mini Gerbera Maceta
  //   id: 'miniGerbera', 
  //   name: 'Mini Gerbera Maceta', 
  //   price: 20, 
  //   description: 'Con 2 capullos.', 
  //   category: 'Macetitas', 
  //   features: [], 
  //   imageUrl: '/assets/products/video3/mini_gerbera.avif' 
  // },
  // { 
  //   // Mini Tulipanes Maceta
  //   id: 'miniTulipanes', 
  //   name: 'Mini Tulipanes Maceta', 
  //   price: 23, 
  //   description: 'Incluye: 6 mini tulipanes, dedicatoria.', 
  //   category: 'Macetitas', 
  //   features: [], 
  //   imageUrl: '/assets/products/video3/mini_tulipanes.avif' 
  // },
  // { 
  //   // Mini Margaritas Maceta
  //   id: 'miniMargaritas', 
  //   name: 'Mini Margaritas Maceta', 
  //   price: 23, 
  //   description: 'Incluye: 5 mini margaritas, dedicatoria.', 
  //   category: 'Macetitas',
  //   features: [], 
  //   imageUrl: '/assets/products/video3/mini_margaritas.avif' 
  // },
]

const PRODUCTS_RAMOS: Product[] = [
  {
    // 5 lirios, 2 lirios cerrados
    id: 'tulipeiaFemenina',
    name: 'Tulipeia Femenina',
    price: 50,
    description: 'Incluye: 5 lirios, 2 lirios cerrados, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Temáticos',
    features: [],
    imageUrl: '/assets/products/video1/5.avif' 
  },
  {
    // 40 margaritas
    id: 'blionVibrante',
    name: 'Blion Vibrante',
    price: 50,
    description: 'Incluye: 30 margaritas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Temáticos',
    features: [],
    imageUrl: '/assets/products/video1/6.avif' 
  },
  { 
    // 3 lirios, 2 tulipanes, 2 ramitas
    id: 'peadasSutil', 
    name: 'Peadas Sutil', 
    price: 40, 
    description: 'Incluye: 3 lirios, 2 tulipanes, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Temáticos', 
    features: [], 
    imageUrl: '/assets/products/video1/7.avif' 
  },
  { 
    // 10 plantas, 4 palitos
    id: 'macetasDeVida', 
    name: 'Macetas de Vida', 
    price: 50, 
    description: 'Incluye: 10 plantas, 4 palitos, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Temáticos', 
    features: [], 
    imageUrl: '/assets/products/video1/9.avif' 
  },
  { 
    // 18 Tulipanes
    id: 'detalleDea', 
    name: 'Detalle Dea', 
    price: 80, 
    description: 'Incluye: 18 tulipanes, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Temáticos', 
    features: [], 
    imageUrl: '/assets/products/video1/10.avif' 
  },
  {
    // 8 tulipanes premium
    id: 'ramoIvette',
    name: 'Ramo Ivette',
    price: 55,
    description: 'Incluye: 8 tulipanes premium, papel coreano, lazo y dedicatoria.',
    category: 'Ramos de Tulipanes',
    features: [],
    imageUrl: '/assets/products/video2/8_tulipanes.avif'
  },
  {
    // 10 tulipanes y 6 margaritas
    id: 'ramoValeria',
    name: 'Ramo Valeria',
    price: 60,
    description: 'Incluye: 10 tulipanes, 6 margaritas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos de Tulipanes',
    features: [],
    imageUrl: '/assets/products/video2/10_tulipanes_margaritas.avif'
  },
  { 
    // 6 gerberas en tonos rosa
    id: 'dulzura', 
    name: 'Dulzura', 
    price: 45,
    description: 'Incluye: 6 gerberas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video3/dulzura.avif' 
  },
  { 
    // 7 tulipanes, 9 mini margaritas
    id: 'princesa',
    name: 'Princesa',
    price: 55,
    description: 'Incluye: 7 tulipanes, 9 margaritas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video3/princesa.avif'
  },
  { 
    // 5 rosas, 4 mini margaritas
    id: 'amorEterno',
    name: 'Amor Eterno',
    price: 40,
    description: 'Incluye: 5 rosas, 4 margaritas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video3/amor_eterno.avif'
  },
  { 
    // 6 tulipanes, 2 lirios
    id: 'corazon',
    name: 'Corazón',
    price: 55,
    description: 'Incluye: 6 tulipanes, 2 lirios, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video3/corazon.avif'
  },
  { 
    // 12 gerberas y mariposa
    id: 'notasAmor',
    name: 'Notas de Amor',
    price: 80,
    description: 'Incluye: 12 gerberas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos Especiales',
    features: [],
    imageUrl: '/assets/products/video3/notas_amor.avif'
  },
  { 
    id: 'ramoTresAmores', 
    name: 'Ramo Tres Amores', 
    price: 25, 
    description: 'Incluye: 3 tulipanes, 5 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video4/tulipanes_margaritas.avif' 
  },
  { 
    id: 'ramoAmorPuro', 
    name: 'Ramo Amor Puro', 
    price: 25, 
    description: 'Incluye: 3 tulipanes, 4 margaritas, 1 lirio, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos Especiales', 
    features: [], 
    imageUrl: '/assets/products/video4/ramo_tulipanes_lirios.avif' 
  },
  { 
    // 8 tulipanes
    id: 'ramoDespertar', 
    name: 'Ramo Despertar', 
    price: 50, 
    description: 'Incluye: 8 tulipanes, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos', 
    features: [], 
    imageUrl: '/assets/products/video4/ramo_tulipanes.avif' 
  },
  { 
    // 7 girasoles, 12 margaritas
    id: 'ramoSol',
    name: 'Ramo Sol',
    price: 55,
    description: 'Incluye: 7 girasoles, 10 margaritas, papel coreano, lazo y dedicatoria.',
    category: 'Ramos',
    features: [],
    imageUrl: '/assets/products/video4/ramo_girasoles.avif'
  },
  { 
    // 2 lirios, 4 tulipanes
    id: 'ramoOlivia', 
    name: 'Ramo Olivia', 
    price: 40, 
    description: 'Incluye: 3 lirios, 2 tulipanes, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos', 
    features: [], 
    imageUrl: '/assets/products/video4/ramo_2_lirios_tulipanes.avif' 
  },
  { 
    id: 'bouquetMargaritas', 
    name: 'Bouquet de Margaritas', 
    price: 60, 
    description: 'Incluye: 25 mini margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos', 
    features: [], 
    imageUrl: '/assets/products/video4/bouquet_margaritas.avif' 
  },
  { 
    // 5 Lirios, 4 tulipanes, 7 margaritas
    id: 'bouquetRosita', 
    name: 'Bouquet Rosita', 
    price: 60,
    description: 'Incluye: 5 lirios, 4 tulipanes, 7 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos', 
    features: [], 
    imageUrl: '/assets/products/video4/bouquet_rosita.avif' 
  },
  { 
    id: 'princesaRapunzel', 
    name: 'Princesa Rapunzel', 
    price: 60, 
    description: 'Incluye: 1 lirio ondeado, 1 tulipán, 1 gerbera, 2 margaritas, papel coreano, lazo y dedicatoria.', 
    category: 'Ramos', 
    features: [], 
    imageUrl: '/assets/products/video4/princesa_rapunzel.avif' 
  },
  
]

const PRODUCTS_LUZ: Product[] = [
  { 
    // 6 tulipanes con luces
    id: 'tulipanesConLuces', 
    name: 'Tulipanes con Luces', 
    price: 55, 
    description: 'Incluye: 6 tulipanes, papel coreano, lazo y dedicatoria.', 
    category: 'Detalles con Luz', 
    features: [], 
    imageUrl: '/assets/products/video2/6_tulipanes_luces.avif' 
  },
  // { 
  //   // 6 girasoles con luces
  //   id: 'ramoAnaLuces',
  //   name: 'Ramo Ana Luces',
  //   price: 60,
  //   description: 'Incluye: Papel Coreano, Lazo, Dedicatoria y Luces LED.',
  //   category: 'Detalles con Luz',
  //   features: [],
  //   imageUrl: '/assets/products/video2/6_girasoles.avif'
  // },
  { 
    // 12 tulipanes, 2 lirios con luces
    id: 'evangeline',
    name: 'Evangeline',
    price: 75,
    description: 'Incluye: 12 tulipanes, 2 lirios, papel coreano, lazo y dedicatoria.',
    category: 'Detalles con Luz',
    features: [],
    imageUrl: '/assets/products/video3/evangeline.avif'
  }
]

const PRODUCTS_BASICOS: Product[] = [
  {
    id: 'unSentimiento',
    name: 'Un Sentimiento',
    category: 'Premium',
    price: 10,
    description: 'Incluye: Papel Coreano, Lazo y dedicatoria',
    imageUrl: '/assets/products/oficial/un_sentimiento.avif',
    features: [],
    available: ['Rosa', 'Girasol', 'Tulipán', 'Margarita', 'Lirio'],
  },
  {
    id: 'floresElección',
    category: 'Personalizados',
    name: 'Flores a tu elección',
    imageUrl: '/assets/products/video5/flores_eleccion.avif',
    price: 10,
    features: [],
    available: ['Rosa', 'Girasol', 'Tulipán', 'Margarita', 'Lirio'],
    description: 'Incluye: Porta flor, Lazo y dedicatoria',
  }
]

export const MOM_CATALOG_PRODUCTS: Product[] = [
  ...PRODUCTS_UNO,
  ...PRODUCTS_DOS,
  ...PRODUCTS_TRES,
  ...PRODUCTS_MACETAS,
  ...PRODUCTS_RAMOS,
  ...PRODUCTS_LUZ,
  ...PRODUCTS_BASICOS,
  // ...VIDEO1_PRODUCTS,
  // ...VIDEO2_PRODUCTS,
  // ...VIDEO3_PRODUCTS,
  // ...VIDEO4_PRODUCTS,
  // ...VIDEO5_PRODUCTS,
  // ...VIDEO6_PRODUCTS,
  // ...VIDEO7_PRODUCTS
];
